/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-members" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-members" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-members" */ `./edit.vue` );
const Summary = () => import( /* webpackChunkName: "group-members" */ `./summary.vue` );

export const members_routes = {
	path: `members`,
	children: [
		{
			path: ``,
			name: `list-members`,
			component: List,
			meta: {
				title: `Members`
			}
		},
		{
			path: `summary`,
			name: `members-summary`,
			component: Summary,
			meta: {
				title: `Members Summary`
			}
		},
		{
			path: `new`,
			name: `add-member`,
			component: Add,
			meta: {
				title: `Add Member`
			}
		},
		{
			path: `:uuid`,
			name: `edit-member`,
			component: Edit,
			meta: {
				title: `Edit Member`
			}
		}
	]
};
